import { render, staticRenderFns } from "./MaterialStatsAdmin.vue?vue&type=template&id=9d7ecb24&"
import script from "./MaterialStatsAdmin.vue?vue&type=script&lang=js&"
export * from "./MaterialStatsAdmin.vue?vue&type=script&lang=js&"
import style0 from "./MaterialStatsAdmin.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCol,VIcon})
